export default "__VITE_ASSET__DZ21vLeI__"